module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vbl-icon-example"
  }, [_c('vbl-icon', {
    attrs: {
      "type": "ion-ionic",
      "size": "26"
    }
  }), _c('br'), _c('hr'), _c('strong', [_vm._v("所有图标：")]), _c('all-icons')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cad83fb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblIcon/example/vblIconExample.vue
// module id = 271
// module chunks = 0